/* * @Author: zhaofy * @Date: 2018-01-25 22:55:56 * @Last Modified by: 李志远 *
@Last Modified time: 2022-08-We 08:49:57 */
<template>
  <div class="good-detail-page">
    <div class="breadcrumb">
      首页 > {{ goods.catName }} > {{ curGoodInfo.name }}
    </div>
    <!-- 下半部分，购买详情 -->
    <div class="buy-detail">
      <!-- 图片缩放 -->
      <gallery :gallery="gallery"></gallery>
      <!-- 商品信息以及店铺 -->
      <div class="summary">
        <div class="g-name">
          {{ curGoodInfo.name }}
          <label v-show="goods.goods_transfee_charge === 1">包邮</label>
        </div>
        <!-- 商品信息 -->
        <div class="info">
          <div class="meta">
            <dl>
              <dt v-show="curGoodInfo.mktprice">
                <span
                  v-show="goods.sourceFlag != '4' && goods.sourceFlag != '3'"
                  >价　　格：</span
                ><span v-show="goods.sourceFlag == '3'">市场价：</span
                ><span v-show="goods.sourceFlag == '4'">会员价：</span>
              </dt>
              <dd v-show="curGoodInfo.mktprice">
                <strong class="linear"
                  >¥ {{ curGoodInfo.mktprice }}<i class="linear"></i
                ></strong>
              </dd>
              <dt v-show="curGoodInfo.price">
                <span
                  v-show="
                    goods.sourceFlag != '2' &&
                    goods.sourceFlag != '3' &&
                    goods.sourceFlag != '4'
                  "
                  >会员价：</span
                ><span v-show="goods.sourceFlag == '2'">特　　价：</span
                ><span v-show="goods.sourceFlag == '3'">批发价：</span
                ><span v-show="goods.sourceFlag == '4'">店长采购价：</span>
              </dt>
              <dd v-show="curGoodInfo.price">
                <strong>¥ {{ curGoodInfo.price }}</strong>
              </dd>
              <dt v-show="curGoodInfo.batchPrice > 0">批发价：</dt>
              <dd v-show="curGoodInfo.batchPrice > 0">
                <strong nctype="goods_price"
                  >¥ {{ curGoodInfo.batchPrice }}</strong
                >
                <span
                  style="
                    cursor: pointer;
                    padding: 2px 6px;
                    -moz-border-radius: 5px;
                    -webkit-border-radius: 5px;
                    border-radius: 5px;
                    background-color: #fe9d01;
                    color: #fff;
                  "
                >
                  <router-link
                    :to="{
                      path: '/goods',
                      query: { goods_id: curGoodInfo.oriGood },
                    }"
                    style="font-size: 12px; color: #fff"
                    target="_blank"
                    title="查看原商品"
                    >查看原商品</router-link
                  >
                </span>
              </dd>
              <!--<dt v-show="curGoodInfo.peerPrice>0">同城价：</dt>-->
              <!--<dd v-show="curGoodInfo.peerPrice>0"><strong> ¥  {{curGoodInfo.peerPrice}}</strong></dd>-->
              <dt
                v-show="
                  curGoodInfo.couponAmount > 0 || goods.couponAmountByChain > 0
                "
              >
                现金券抵扣：
              </dt>
              <!--普通商品购物卷抵扣-->
              <dd
                v-show="curGoodInfo.couponAmount > 0 && goods.sourceFlag != '2'"
              >
                <strong>¥ {{ curGoodInfo.couponAmount }}</strong>
              </dd>
              <!--直供专区商品购物卷抵扣-->
              <!-- <dd v-show="goods.couponAmountByChain>0 && goods.sourceFlag == '2'"><strong>¥
                  {{goods.couponAmountByChain}}</strong></dd> -->
              <!--首购商品专项补助积分-->
              <dt v-show="curGoodInfo.selfShoppingPv">自营积分抵扣：</dt>
              <!--自营积分抵扣-->
              <dd v-show="curGoodInfo.selfShoppingPv">
                <strong>¥ {{ curGoodInfo.selfShoppingPv }}</strong>
              </dd>

              <dt v-show="goods.subsidyPoint > 0 && goods.sourceFlag != '4'">
                补助积分：
              </dt>
              <dd v-show="goods.subsidyPoint > 0 && goods.sourceFlag != '4'">
                <strong> {{ goods.subsidyPoint }}</strong>
              </dd>
              <!--起批量屏蔽<dt v-show="curGoodInfo.batchPrice>0">起批量：</dt>
              <dd v-show="curGoodInfo.batchPrice>0">{{curGoodInfo.batchCount}}</dd>-->
              <dt
                v-show="curGoodInfo.batchPrice === 0 && goods.sourceFlag != '4'"
              >
                产品积分：
              </dt>
              <dd
                v-show="curGoodInfo.batchPrice === 0 && goods.sourceFlag != '4'"
              >
                <strong>{{ curGoodInfo.pv }}</strong>
              </dd>
            </dl>
            <ul v-if="!goods.isSelf || goods.buyNum > 0">
              <li>
                <p class="color1">{{ goods.buyNum }}</p>
                <p>累计售出</p>
              </li>
              <li class="line3">
                <p class="color2">{{ goods.memberCommentCount }}</p>
                <p>条评论</p>
              </li>
              <li>
                <p class="color3">{{ goods.goodsTypeDisplay }}</p>
                <p>商品类型</p>
              </li>
            </ul>
          </div>
          <!-- 商品分类选择，有就显示 -->
          <div v-if="currChoose.detail.length !== 0" class="choose">
            <div
              v-for="(fItem, fIndex) in this.goodsSkuList.pOrderlist"
              :key="fIndex"
              class="li"
            >
              <div class="dt">{{ fItem }}：</div>
              <div
                v-for="(cItem, cIndex) of choose[fItem]"
                :key="cIndex"
                class="item"
                :class="{
                  selected: cIndex === currChoose.detail[fIndex].index,
                }"
                @click.stop.prevent="cChoose(fIndex, cItem, cIndex)"
              >
                <a :title="fItem">{{ cItem }}</a>
              </div>
            </div>
          </div>
          <div class="key">
            <dl>
              <dt>购买数量：</dt>
              <dd class="figure-input">
                <a @click.stop.prevent="buyNumOpn('-')"><i>-</i></a>
                <input

                  type="text"
                  size="3"
                  maxlength="8"
                  v-model="buyNum"
                  @keyup="changeNumber"
                  oninput="value = value ? value.replace(/[^\d]/g,'') : ''"
                />
                <a @click.stop.prevent="buyNumOpn('+')"><i>+</i></a>
                <em v-if="!goods.isSelf"
                  >(当前库存<strong>{{ curGoodInfo.idsStore }}</strong
                  >件)</em
                >
              </dd>
              <div class="clear"></div>
            </dl>
            <div
              class="btn clearfix"
              v-if="!goods.isSelf && curGoodInfo.idsStore == 0"
            >
              <p>抱歉，暂无库存</p>
            </div>
            <div class="btn clearfix" v-else>
              <a v-if="isHaveType" class="buynow" @click.stop.prevent="cBuynow"
                >立即购买</a
              ><!-- 立即购买-->
              <a
                v-if="isHaveType"
                class="addcart"
                @click.stop.prevent="cAddCart"
                >添加到购物车
                <!-- 加入购物车-->
              </a>
              <a v-if="!isHaveType" class="nobuynow">立即购买</a
              ><!-- 立即购买-->
              <a v-if="!isHaveType" class="noaddcart"
                >添加到购物车
                <!-- 加入购物车-->
              </a>
            </div>
            <div class="clear"></div>
            <div class="share">
              <a @click.stop.prevent="cShare">
                <span></span>
                <span v-if="!isFavorite">收藏商品</span>
                <span v-if="isFavorite">取消收藏</span>
              </a>
            </div>
          </div>
        </div>
        <!-- 店铺信息 -->
        <div class="store">
          <div class="title">店铺信息</div>
          <div class="s-name" :title="storeInfo.storeName">
            <span>商&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;铺：</span
            >{{ storeInfo.storeName }}
          </div>
          <div class="rating">
            <span>综合评分：</span><span></span>{{ credit }}
          </div>
          <div class="credit-name">店铺动态评分（满分5分）</div>
          <div class="credit">描述相符：{{ storeInfo.storeDesccredit }}</div>
          <div class="credit">服务态度：{{ storeInfo.storeServicecredit }}</div>
          <div class="credit delivery">
            发货速度：{{ storeInfo.storeDeliverycredit }}
          </div>
          <!-- <router-link to="" class="online">
            <img src="//static.kxymall.com/images/chart.png">
          </router-link> -->
          <div class="btn">
            <a @click.stop.prevent="cStore"><span>进入商家店铺</span></a>
          </div>
        </div>
      </div>
      <div class="clear"></div>
    </div>
    <!-- 下半部分 -->
    <div class="detail">
      <!-- 左边店铺卡片 -->
      <card :storeId="goods.storeId" :catList="catList"></card>
      <!-- 商品详情等 -->
      <detail
        :goodsId="goods.goods_id"
        :storeId="goods.storeId"
        :goodsIntros="goods.intros"
        :goodsVideo="goods.goodsVideo"
      ></detail>
      <div class="clear"></div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import detail from "@/views/goods-godule/module-detail-content";
import card from "@/views/goods-godule/module-card";
import gallery from "@/views/goods-godule/module-gallery";
import { cartBuy } from "api/goodsCart";
import { MOBILE_REG } from "utils/url";
import { cutOutNum } from "utils/tool";
import {
  getGoodsList,
  getShopsInfo,
  favoriteAdd,
  favoriteDelete,
  getAllCatList,
} from "@/api/goods";
export default {
  name: "goods",
  components: {
    detail,
    card,
    gallery,
  },
  created() {
    // 获取传过来的商品id
    this.goodsId = this.$route.query.goods_id;
    // 请求商品详细信息
    this.getInfo();
  },
  data() {
    return {
      storeId: "", // 店铺id
      favoriteId: "", // 商品收藏id
      goodsId: "", // 商品id
      regUrl: MOBILE_REG,
      goods: {}, // 商品信息
      storeInfo: {}, // 店铺信息
      catList: [], // 店铺商品分类列表
      gallery: {
        // 商品海报
        bigImg: "",
        list: [],
        currIndex: -1,
      },
      choose: {}, // 商品所有的分类集合
      currChoose: {
        // 被选中的商品分类
        desc: "",
        currId: "",
        detail: [],
      },
      buyNum: 1, // 购买数量
      currNum: 0, // 当前库存
      isFavorite: false, // 商品是否收藏
      isHaveType: true, // 是否有规格
    };
  },
  watch: {
    // 监听路由，页面内容点击其他商品，重新获取数据
    $route() {
      if (
        this.$route.path === "/goods" &&
        this.$route.query.goods_id !== this.goodsId
      ) {
        this.$router.go(0);
        //          this.goodsId = this.$route.query.goods_id
        //          this.getInfo()
      }
    },
  },
  computed: {
    ...mapGetters(["sid"]),
    // 计算是否已登陆
    isLogin() {
      return this.$store.getters.sid.length > 0 ? true : false;
    },
    // 店铺综合评分
    credit() {
      const pf = (
        (parseFloat(this.storeInfo.storeDeliverycredit) +
          parseFloat(this.storeInfo.storeServicecredit) +
          parseFloat(this.storeInfo.storeDesccredit)) /
        3
      ).toFixed(2);
      return isNaN(pf) ? 0 : pf;
    },
    curGoodInfo() {
      return {
        mktprice: this.goods.mktprice,
        name: this.goods.name,
        price: this.goods.price,
        pv: cutOutNum(this.goods.pv),
        idsStore: this.currNum,
        batchCount: this.goods.batchAmount,
        batchPrice: this.goods.batchPrice,
        oriGood: this.goods.oriGoodsId,
        goods_id: this.goods.goods_id,
        peerPrice: this.goods.peerPrice,
        couponAmount: this.goods.couponAmount,
        selfShoppingPv: this.goods.selfShoppingPv,
      };
    },
  },
  methods: {
    buyNumOpn(type) {
      if (type == "-") {
        this.buyNum--;
      }
      if (type == "+") {
        this.buyNum++;
      }
      if (this.goods.sourceFlag == 3 && this.goods.minBuyNum) {
        if (this.buyNum < this.goods.minBuyNum) {
          this.buyNum = this.goods.minBuyNum;
        } else if (this.buyNum > this.currNum)
          this.buyNum = this.goods.minBuyNum;
      } else {
        if (this.buyNum < 1) this.buyNum = 1;
        else if (this.buyNum > this.currNum) this.buyNum = this.currNum;
      }
    },
    // 获取商品信息
    getInfo() {
      getGoodsList({
        goodsId: this.goodsId,
        platfrom: 0,
      }).then((res) => {
        if (res.resCode === 1) {
          this.currChoose.detail = [];
          this.currChoose.desc = "";
          this.goods = res.data;
          this.currNum = this.goods.store; // 商品库存
          this.gallery.bigImg = this.goods.goodsGalleryList[0].big; // 商品海报大图，取第一个
          this.gallery.list = this.goods.goodsGalleryList; // 商品海报小图列表
          if (this.goods.goodsVideo) {
            this.gallery.video = this.goods.goodsVideo;
          }
          this.isFavorite = Boolean(res.data.favoriteId); // 是否收藏
          this.favoriteId = res.data.favoriteId; // 收藏id
          this.storeId = res.data.storeId; // 店铺id
          this.goods.goodsTypeDisplay = this.getGoodType(this.goods.goodsType);
          if (this.goods.sourceFlag == 3 && this.goods.minBuyNum) {
            if (this.buyNum < this.goods.minBuyNum)
              this.buyNum = this.goods.minBuyNum;
            else if (this.buyNum > this.currNum) this.buyNum = this.currNum;
          }
          // 获取店铺信息
          this.getStoreInfo();

          // 整理商品中所有的分类集合，并设置当前已选中分类
          if (
            !res.data.goodsSkuList[0] ||
            res.data.goodsSkuList[0].rowslist.length === 0
          ) {
            return;
          } else {
            this.goodsSkuList = res.data.goodsSkuList[0];
            this.choose = res.data.goodsSkuList[0].rowslist;
            this.goodsSkuList.pOrderlist.map((pOrder) => {
              let name = this.goodsSkuList.currlist[pOrder];
              this.choose[pOrder].map((choose, cIndex) => {
                if (name === choose) {
                  this.currChoose.detail = this.currChoose.detail.concat({
                    name: name,
                    index: cIndex,
                  });
                  // 记录所有选择的分类名称
                  this.currChoose.desc += name + "_";
                }
              });
            });
          }
        } else if (res.resCode === 0) {
          // 返回不成功，进入默认页面
          this.$router.replace({
            path: "/notGood",
            query: { goods_id: this.goodsId },
          });
        }
      });
    },
    // 获取店铺信息
    getStoreInfo() {
      getShopsInfo({
        storeId: this.storeId,
      }).then((res) => {
        if (res.resCode === 1) {
          this.storeInfo = res.data.storeDetailDTO; // 店铺信息
          //this.catList = res.data.catList // 店铺分类信息
        }
      });
      getAllCatList({
        storeId: this.storeId,
        catId: "0",
      }).then((res) => {
        if (res.resCode === 1) {
          this.catList = res.data; // 商品分类信息
        }
      });
    },
    // 进入商家店铺
    cStore() {
      this.$router.push({
        path: "/shop",
        query: { tab: 2, store_id: this.storeId },
      });
    },
    // 选择商品类型
    cChoose(fIndex, cItem, cIndex) {
      console.log(fIndex, cItem, cIndex);
      this.currChoose.desc = "";
      this.currChoose.detail[fIndex].index = cIndex;
      this.currChoose.detail[fIndex].name = cItem;
      let shopName = "";
      for (let item of this.currChoose.detail) {
        this.currChoose.desc += item.name + "_";
        shopName += item.name + " ";
      }

      let goodsNum = JSON.parse(this.goodsSkuList.gdidsStorejson)[
        this.currChoose.desc
      ];

      let goodsId = JSON.parse(this.goodsSkuList.gdidsjson)[
        this.currChoose.desc
      ];
      if (Number(goodsNum) > 0) {
        this.isHaveType = true;
        this.$router.push({
          path: "/goods",
          query: {
            goods_id: goodsId,
          },
        });
      } else {
        this.curGoodInfo.name =
          this.curGoodInfo.name.substring(
            0,
            this.curGoodInfo.name.indexOf(" ")
          ) +
          " " +
          shopName;
        this.isHaveType = false;
      }
    },
    // 收藏或取消收藏商品
    cShare() {
      if (this.isLogin) {
        // 登录情况
        if (!this.isFavorite) {
          let data = {
            goodsId: this.goodsId,
            type: 1,
          };
          favoriteAdd(data).then((res) => {
            if (res.resCode === 1) {
              this.isFavorite = true;
              this.favoriteId = res.data.favoriteId;
            }
            this.$Message.info(res.resDesc);
          });
        } else {
          let data = {
            goodsId: this.goodsId,
            type: 1,
          };
          favoriteDelete(data).then((res) => {
            if (res.resCode === 1) {
              this.isFavorite = false;
            }
            this.$Message.info(res.resDesc);
          });
        }
      } else {
        // 非登录情况
        this.$Message.info("请先登录");
      }
    },

    changeNumber(e) {
      // if (!e.target.value) {
      //   e.target.value = 1;
      //   return;
      // }
      if (e.target.value && e.target.value == 0) {
        e.target.value = 1;
        return;
      }
    },

    // 立即购买
    cBuynow() {
      if (this.isLogin) {
        if (this.buyNum > 0) {
          if (
            this.curGoodInfo.batchPrice > 0 &&
            this.buyNum < this.curGoodInfo.batchCount
          ) {
            // 批发商品 需判断购买量是否小于起批量
            this.$Message.info("购买批发价商品，购买数量不能低于起批量");
            return;
          }
          cartBuy({
            buyFlag: 1,
            goodsId: this.goodsId,
            goodsNum: this.buyNum,
          }).then((res) => {
            if (res.resCode === 1) {
              const data = res.data;
              //判断是否直供专区商品 或出厂价商品
              if (this.goods.sourceFlag == "1") {
                this.$router.push({
                  path: "/checkout",
                  query: {
                    storeId: this.storeId,
                    //itemId: data.itemId,
                    num: this.buyNum,
                    goodsId: this.goodsId,
                    // selfShoppingPv: this.goods.selfShoppingPv,
                    //coupon: this.curGoodInfo.couponAmount * this.buyNum,
                    source_flag: this.goods.sourceFlag,
                    coupon: data.coupon,
                    chainGoodsProfit: data.chainGoodsProfit,
                    checkAtTheShoppingPv: data.checkAtTheShoppingPv,
                    couponLimit: data.checkAtTheCoupon || data.couponLimit,
                    selfShoppingPv: data.selfShoppingPv,
                  },
                });
              } else if (
                this.goods.sourceFlag == "2" ||
                this.goods.sourceFlag == "3"
              ) {
                this.$router.push({
                  path: "/checkout",
                  query: {
                    storeId: this.storeId,
                    itemId: res.data.itemId,
                    num: this.buyNum,
                    goodsId: this.goodsId,
                    coupon: this.goods.couponAmountByChain,
                    source_flag: this.goods.sourceFlag,
                    chainGoodsProfit: data.chainGoodsProfit,
                    checkAtTheShoppingPv: data.checkAtTheShoppingPv,
                    couponLimit: data.couponLimit || data.checkAtTheCoupon,
                    selfShoppingPv: data.selfShoppingPv,
                  },
                });
              } else {
                this.$router.push({
                  path: "/checkout",
                  query: {
                    storeId: this.storeId,
                    itemId: res.data.itemId,
                    num: this.buyNum,
                    goodsId: this.goodsId,
                    coupon: this.curGoodInfo.couponAmount * this.buyNum,
                    chainGoodsProfit: data.chainGoodsProfit,
                    checkAtTheShoppingPv: data.checkAtTheShoppingPv,
                    couponLimit: data.couponLimit || data.checkAtTheCoupon,
                    selfShoppingPv: data.selfShoppingPv,
                  },
                });
              }
            } else {
              this.$Modal.error({
                content: res.resDesc,
                onOk: () => {},
              });
            }
          });
        } else {
          this.$Message.info("请填写购买数量");
        }
      } else {
        // 游客给出提示
        this.$Modal.confirm({
          title: "温馨提示",
          content: "<p>您当前是游客身份，游客身份不能购买商品！</p>",
          okText: "马上登录",
          closable: true,
          onOk: () => {
            // let goodsUrl = window.location.href;
            // window.localStorage.setItem('redirectUrl', goodsUrl);
            document.cookie =
              "loginReferrer=" +
              escape(location.href.split(location.host)[1]) +
              "; path=/";
            this.$router.push({ path: "/login" });
          },
          cancelText: "立即注册",
          onCancel: () => {
            /*window.open(this.regUrl);*/
            this.$router.push({ path: "/register" });
          },
        });
      }
    },
    // 添加购物车
    cAddCart() {
      if (this.isLogin) {
        if (
          this.curGoodInfo.batchPrice > 0 &&
          this.buyNum < this.curGoodInfo.batchCount
        ) {
          // 批发商品 需判断购买量是否小于起批量
          this.$Message.info("购买批发价商品，购买数量不能低于起批量");
          return;
        }
        this.$store
          .dispatch("addCart", {
            id: this.goodsId,
            num: this.buyNum,
          })
          .then((res) => {
            if (res.resCode === 1) {
              //this.$Message.info('成功加入购物车');
              //添加购物车成功增加弹框提示
              this.$Modal.confirm({
                title: "温馨提示",
                content: "<p>恭喜您！商品已添加到您的购物车</p>",
                okText: "去结算",
                closable: true,
                onOk: () => {
                  this.$router.push({ path: "/shopping-cart" });
                },
                cancelText: "继续购物",
                onCancel: () => {},
              });
            } else {
              this.$Message.info(res.resDesc);
            }
          });
      } else {
        this.$Modal.confirm({
          title: "温馨提示",
          content: "<p>您当前是游客身份，游客身份不能加入购物车！</p>",
          okText: "马上登录",
          onOk: () => {
            document.cookie =
              "loginReferrer=" +
              escape(location.href.split(location.host)[1]) +
              "; path=/";
            this.$router.push("/login");
          },
          cancelText: "取消",
          onCancel: () => {},
        });
      }
    },
    // 初始化数字或字符串为两位小数结尾
    returnFloat(value) {
      var value = Math.round(parseFloat(value) * 100) / 100;
      var xsd = value.toString().split(".");
      if (xsd.length == 1) {
        value = value.toString() + ".00";
        return value;
      }
      if (xsd.length > 1) {
        if (xsd[1].length < 2) {
          value = value.toString() + "0";
        }
        return value;
      }
    },
    getGoodType(type) {
      let map = {
        normal: "普通商品",
        batch: "批发价商品",
      };
      let res = map[type];
      if (!res) return "未知类型";
      return res;
    },
  },
  // 销毁组件，返回刷新
  deactivated() {
    this.$destroy();
  },
};
</script>
<style scoped lang="less">
a {
  color: #333;
}
.good-detail-page {
  margin: 0 auto;
  width: 1200px;
  .breadcrumb {
    padding: 12px 18px;
    font: 14px/1.2em "Microsoft Yahei";
  }
  .buy-detail {
    overflow: hidden;
    position: relative;
  }
  .summary {
    float: right;
    width: 790px;
    height: 100%;
    .g-name {
      font: 700 16px/1.2em "Microsoft Yahei";
      /*text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;*/
      display: block;
      padding-bottom: 10px;
      border-bottom: dotted 1px #ccc;
      label {
        background-color: red;
        color: white;
        font-size: 12px;
        padding: 1px;
      }
    }
    .info {
      float: left;
      width: 560px;
      dl {
        display: block;
        padding: 0;
        margin: 5px 0;
        clear: both;
        width: 100%;
        dt {
          line-height: 30px;
          display: inline;
          text-align: right;
          white-space: nowrap;
          width: 75px;
          float: left;
        }
        dd {
          line-height: 30px;
          display: inline;
          float: left;
          width: 450px;
          margin-left: 4px;
        }
      }

      .meta {
        width: 560px;
        clear: both;
        margin-bottom: 5px;
        strong {
          font-size: 20px;
          font-weight: 600;
          color: #d93600;
          display: inline-block;
          position: relative;
          vertical-align: middle;
          overflow: hidden;
          .linear::before {
            content: "";
            position: absolute;
            left: 0;
            top: -15px;
            width: 100%;
            height: 30px;
            box-sizing: border-box;
            border-bottom: 1px solid #d93600;
            transform: rotateZ(15deg) scale(1);
          }
        }

        ul {
          border: 1px dotted #c9c9c9;
          border-width: 1px 0;
          margin: 5px 0 0;
          padding: 15px 0 10px;
          position: relative;
          overflow: hidden;
          _zoom: 1;
          clear: both;
          display: flex;
          li {
            float: left;
            width: 33%;
            text-align: center;
            position: relative;
            left: -1px;
            border-left: 1px solid #e5dfda;
            flex: 1;
            height: auto;
            p:first-child {
              font-size: 18px;
            }
            p:last-child {
              color: #999;
            }
            .color1 {
              color: #333;
            }
            .color2 {
              color: #38b;
            }
            .color3 {
              font-size: 1em;
              color: #280;
            }
          }
        }
      }
      .choose {
        width: 550px;
        padding-top: 10px;
        margin: 5px 0 20px;
        clear: both;
        .li {
          width: 516px;
          padding: 5px 0 5px 72px;
          float: left;
          .dt {
            float: left;
            min-width: 72px;
            margin-left: -72px;
            margin-top: 5px;
            display: inline;
            text-align: right;
            line-height: 30px;
            font-family: simsun;
          }
          .item {
            position: relative;
            float: left;
            margin-right: 8px;
            margin-top: 5px;
            a {
              display: block;
              white-space: nowrap;
              text-decoration: none;
              border: 1px solid #ccc;
              background: #fff;
              padding: 5px 6px;
              min-width: 45px;
              text-align: center;
            }
          }
          .selected a {
            border: 2px solid #e4393c;
            padding: 4px 5px;
            &:after {
              content: "";
              position: absolute;
              bottom: 0;
              right: 0;
              width: 15px;
              height: 15px;
              overflow: hidden;
              background: url(//static.kxymall.com/images/goods-invent-selected.gif)
                right bottom no-repeat;
            }
          }
        }
      }
      .key {
        background-color: #f9f9f9;
        border: 1px solid #e9e9e9;
        padding-bottom: 15px;
        width: 560px;
        clear: both;
        .figure-input {
          a i {
            vertical-align: middle;
            display: inline-block;
            color: #999;
            border: 1px solid #d8d8d8;
            padding: 2px 5px;
            height: 13px;
            font-size: 10px;
            line-height: 13px;
            margin: 8px 5px;
          }
          input {
            line-height: 18px;
            width: 30px;
            height: 18px;
            text-align: center;
            border: solid 1px #d8d8d8;
            margin: 6px 0;
            background-color: #f9f9f9;
            padding: 1px 2px 3px 4px;
          }
          em {
            margin-top: 3px;
            margin-left: 20px;
            color: #999;
            strong {
              font-weight: 600;
              color: #555;
              margin: 0 4px;
            }
          }
        }
        .btn {
          zoom: 1;
          float: left;
          display: inline-block;
          height: 32px;
          padding-left: 20px;
          margin: 10px 0 0 0;
          position: relative;
          a {
            font: lighter 16px/20px "Microsoft Yahei";
            color: #fff;
            text-align: center;
            display: inline-block;
            height: 20px;
            padding: 6px 18px;
            margin-right: 10px;
            border-radius: 3px;
            position: relative;
            overflow: hidden;
            box-shadow: 0 0 0 2px rgba(204, 204, 204, 0.25);
          }
          .buynow {
            background-color: #ba7538;
          }
          .addcart {
            background-color: #d93600;
          }

          .nobuynow {
            background-color: #ccc;
          }
          .noaddcart {
            background-color: #ccc;
          }
        }
        .share {
          margin: -25px 22px 0 0;
          float: right;
          display: block;
          width: 108px;
          height: 23px;
          float: right;
          border: solid #e7e7e7 1px;
          border-radius: 3px 0 0 3px;
          position: relative;
          z-index: 1;
          span:first-child {
            background: url(//static.kxymall.com/images/public.png) no-repeat;
            vertical-align: middle;
            display: inline-block;
            width: 16px;
            height: 16px;
            background-position: 0px -190px;
            margin: 3px 8px;
          }
          span:last-child {
          }
        }
      }
    }
    .store {
      position: absolute;
      z-index: 1;
      top: 60px;
      right: 0;
      width: 208px;
      // height: 310px;
      float: right;
      border: solid #d7d7d7;
      border-width: 0 1px 1px;
      div {
        height: 32px;
        line-height: 32px;
        padding: 0px 0px 0px 10px;
      }
      div.title {
        font-size: 14px;
        font-weight: bold;
        color: #666;
        background-color: #e1e1e1;
        padding: 2px 10px;
      }
      div.s-name {
        border-bottom: solid 1px #d7d7d7;
        overflow: hidden;
      }
      div.credit-name {
        font-weight: bold;
      }
      .rating {
        border-bottom: solid 1px #d7d7d7;
        span:nth-child(2) {
          background: url(//static.kxymall.com/images/2014grate.png) no-repeat 0 -18px;
          vertical-align: middle;
          display: inline-block;
          width: 79px;
          height: 17px;
          zoom: 1;
        }
        span:last-child {
          color: #da542e;
        }
      }
      div.credit {
        margin: 0px 10px;
        height: 28px;
        line-height: 28px;
        color: #999;
      }
      .delivery {
        border-bottom: dotted 1px #d7d7d7;
      }
      .online {
        display: block;
        text-align: right;
        padding: 5px 0 7px;
      }
      .btn {
        padding: 8px 0;
        height: 32px;
        background-color: #f7f7f7;
        font-size: 14px;
        text-align: center;
        span {
          display: inline-block;
          width: 106px;
          height: 32px;
          background-color: #fefefe;
          border: solid 1px #e6e6e6;
          &:hover {
          }
        }
      }
    }
  }
  .detail {
    position: relative;
    margin: 10px 0;
  }
}
</style>



// WEBPACK FOOTER //
// good-detail.vue?a37913e2